












import { Component, Prop, Vue } from 'vue-property-decorator';
import { BIconHandThumbsDown, BIconHandThumbsUp } from 'bootstrap-vue';

@Component({
  components: {
    BIconHandThumbsDown,
    BIconHandThumbsUp
  }
})
export default class RateDisplay extends Vue {

  @Prop({ default: true })
  private showNumber!: boolean;

  private plusMinus = 0;

  mounted(){
    if (this.$slots.default?.length) {
      const val = parseInt('' + this.$slots.default[0].text);
      if (val > 0) this.plusMinus = 1;
      else if (val < 0) this.plusMinus = -1;
    }
  }
}
